module.exports = __webpack_public_path__ + "static/media/msdt-landing.687e0c51.png";